import {match} from 'ts-pattern';

import {always} from 'ramda';

import {LegalForm} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export type ConsentContactPersonRequirement = 'required' | 'optional' | 'hidden';

/**
 * A consent for a legal entity is given by its contact person, a self-employed person may name one,
 * and a natural person gives the consent themselves.
 */
export const getConsentContactPersonRequirement = (legalForm: LegalForm | Nullish) =>
  match<LegalForm | Nullish, ConsentContactPersonRequirement>(legalForm)
    .with('LEGAL_ENTITY', always('required'))
    .with('SELF_EMPLOYED', always('optional'))
    .otherwise(always('hidden'));
